import { StoreFeature } from "../../../core/store/types";
import { HTMLEditorSettings } from "../types";

export const settings: StoreFeature<HTMLEditorSettings> = {}